<template>
    <div class="footer">
        <div class="right"><!--Copyright © 2022-2032 银色闪电网络科技有限公司--></div>
    </div>
</template>

<script>
export default {
    name: 'home-footer'
}
</script>

<style scoped>
.footer {
    height: 50px;
    border-top: 1px solid #e9e9e9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}
</style>